import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SpotUpdateConfimationModalComponent } from '../spot-update-confimation-modal/spot-update-confimation-modal.component';
import { SpotCountUpdatePaymentModalComponent } from '../spot-count-update-payment-modal/spot-count-update-payment-modal.component';
import { BookingCycleOption, BOOKING_CYCLE_DROPDOWN, SpotUpdateType } from '@shared/constant/shared.constant';
import { PaymentStatusForMessage } from '@core/models/api-response.model';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { SpotCountUpdateSuccessModalComponent } from '../spot-count-update-success-modal/spot-count-update-success-modal.component';
import { BookingTypeDetails } from '@core/models/booking.model';
import { SpotCountUpdateService } from '@core/services/spot-count-update.service';
@Component({
  selector: 'app-spot-count-update-modal',
  templateUrl: './spot-count-update-modal.component.html',
  styleUrls: ['./spot-count-update-modal.component.scss']
})
export class SpotCountUpdateModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  spotCountUpdateForm: FormGroup;
  radioValue: number;
  bookingDetails: any;
  spotUpdateType = SpotUpdateType;
  errorMessage: string = '';
  paymentStatusEnum = PaymentStatusForMessage;
  bookingCycleOption = BOOKING_CYCLE_DROPDOWN;
  spotCountDifference:number = 0;
  isButtonDisable: boolean = true;
  bookingCycleOptionEnum = BookingCycleOption;
  bookingTypeDetailsEnum = BookingTypeDetails;

  constructor(
    private readonly fb: FormBuilder,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly dialogControlService: DialogControlService,
    private readonly spotCountUpdateService: SpotCountUpdateService
  ) {}

  ngOnInit(): void {
    this.bookingDetails = this.config?.data?.bookingData;
    let previousValue = this.bookingDetails.spotCount;
    this.spotCountUpdateForm = this.fb.group({
      updateAction: [ this.spotUpdateType.NoChange, Validators.required],
      spots: [this.bookingDetails.spotCount, [Validators.required, this.validateSpotCount(this.bookingDetails.spotCount), CustomValidator.validateGreaterThanZero]],
      bookingCycle: [1]
    });

    this.spotCountUpdateForm.get('spots')?.valueChanges.subscribe(currentValue => {
      if (currentValue > previousValue) {
        this.spotCountUpdateForm.get('updateAction')?.setValue(this.spotUpdateType.Increase);
        this.spotCountDifference = currentValue - previousValue;
        this.isButtonDisable = false;
      } else if (currentValue < previousValue) {
        this.spotCountUpdateForm.get('updateAction')?.setValue(this.spotUpdateType.Decrease);
        this.spotCountDifference = previousValue - currentValue;
        this.isButtonDisable = false;
      } else {
        this.spotCountUpdateForm.get('updateAction')?.setValue(0);
        this.spotCountDifference = 0;
        this.isButtonDisable = true;
      }
    });
  }
  
  checkSoptCountAvaility(): void {
    this.updateBookingCycleValidators();
    if (this.spotCountUpdateForm.valid) {
      
      let request = {
        bookingId: this.bookingDetails.id,
        noOfSlots: this.spotCountDifference,
        spotUpdateType: this.spotCountUpdateForm.value.updateAction,
        decreaseSpotFrom: this.bookingDetails.bookingType === this.bookingTypeDetailsEnum.Onetime ? null : this.spotCountUpdateForm.value.bookingCycle,
        PaymentMethodType: this.bookingDetails.paymentStatus === this.paymentStatusEnum.Completed ? this.bookingDetails?.paymentMethodTypeEnumValue : null,
        PaymentMethodId:null

      }
      this.spotCountUpdateService.CheckValidityOnSpotCountIncreaseDecrease(request)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          let data = response?.data;
          
          this.closeDialog();

          if (this.bookingDetails.paymentStatus === this.paymentStatusEnum.Completed  && this.spotCountUpdateForm.value.updateAction === this.spotUpdateType.Increase) {
            this.openSoptUpadtePaymentModal(data);
          } else {
            this.updateSpotCount(data,false);
          }

        }, error: (error) => {
          this.errorMessage = error?.error?.message;
          
        }
      })
    } else {
      this.spotCountUpdateForm.markAllAsTouched();
    }
  }

  updateSpotCount(data, nextBillingCycleChecks: boolean = false): void {
    this.dialogControlService.openDialog(SpotUpdateConfimationModalComponent,
      {
        width: '20%',
        styleClass: 'update-spot-count',
        data: {
          spotChnageType: this.radioValue,
          data: data,
          bookingId: this.bookingDetails.id,
          noOfSlots: this.spotCountDifference,
          spotUpdateType: this.spotCountUpdateForm.value.updateAction,
          decreaseSpotFrom: this.bookingDetails.bookingType === this.bookingTypeDetailsEnum.Onetime ? null : this.spotCountUpdateForm.value.bookingCycle,
          nextBillingCycleChecks: nextBillingCycleChecks
        },
      },
    );
  }

  openSoptUpadtePaymentModal(data):void {
    this.dialogControlService.openDialog(SpotCountUpdatePaymentModalComponent,
      {
        styleClass: 'update-spot-count',
        data: {
          spotChnageType: this.radioValue,
          data: data,
          bookingId: this.bookingDetails.id,
          noOfSlots: this.spotCountDifference,
          spotUpdateType: this.spotCountUpdateForm.value.updateAction,
          decreaseSpotFrom: this.bookingDetails.bookingType === this.bookingTypeDetailsEnum.Onetime ? null : this.spotCountUpdateForm.value.bookingCycle,
        },
      }
    )
  }

  private updateBookingCycleValidators(): void {
    const spotControl = this.spotCountUpdateForm.get('bookingCycle');
    const validators = [];

    if (this.bookingDetails.bookingType === 2) {
      validators.push(Validators.required);
    }

    spotControl?.setValidators(validators);
    spotControl?.updateValueAndValidity();
  }

  validateSpotCount(maxCount: number): ValidatorFn {
    return (control: AbstractControl) => {
      const value = Number(control.value);
      if ((value <= 0 || value >= maxCount) && this.radioValue == 2) {
        return { invalidSpotCount: true };
      }
      return null;
    };
  }

  closeDialog() {
    this.ref.close();
  }

  nextBillingCycleSpotChange(): void {
    const { updateAction, bookingCycle } = this.spotCountUpdateForm.value;
    const spotFromValue = this.bookingDetails.bookingType === this.bookingTypeDetailsEnum.Onetime ? null : bookingCycle;

    const isDecrease = updateAction === this.spotUpdateType.Decrease;
    const apiMethod = isDecrease ? 'decreaseGroupBookingSpot' : 'increaseGroupBookingSpot';

    const request: any = {
      bookingId: this.bookingDetails.id,
      noOfSlots: this.spotCountDifference,
      spotUpdateType: updateAction,
      forceUpdateNextBilling: false,
      [isDecrease ? 'decreaseSpotFrom' : 'increaseSpotFrom']: spotFromValue
    };

    this.spotCountUpdateService[apiMethod](request)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.closeDialog();

          if (response?.data?.isUpcomingRecurringSpotChangeExist) {
            this.updateSpotCount(response, true);
          } else {
            this.dialogControlService.openDialog(SpotCountUpdateSuccessModalComponent, {
              width: '20%',
              data: {
                heading: 'Success',
                bodyText: response?.message,
                isSpotUpdate: true,
                bookingId: this.bookingDetails.id
              }
            });
          }
        },
        error: (error) => {
          this.errorMessage = error?.error?.message;
        }
      });
  }
}
